import * as React from 'react'

function SvgOnefaceIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.243 20.143v-1.615c0-.856-.344-1.677-.956-2.283a3.283 3.283 0 00-2.309-.946H6.265c-.866 0-1.697.34-2.309.946A3.211 3.211 0 003 18.528v1.615M9.121 13.146c1.803 0 3.265-1.445 3.265-3.229 0-1.783-1.462-3.229-3.265-3.229-1.803 0-3.265 1.446-3.265 3.23 0 1.783 1.462 3.229 3.265 3.229zM15.285 8.13l1.418 1.441 4.725-4.805M20.956 8.61v3.364c0 .255-.1.5-.277.68a.937.937 0 01-.668.281h-5.67m-1.89-7.688c0-.255.099-.5.276-.68a.937.937 0 01.668-.281h5.198"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgOnefaceIcon
